<script setup>
    import { storeToRefs } from 'pinia';
    import { ref } from 'vue';
    import { useI18n } from 'vue-i18n';
    import { useSearchStore } from '../store/useSearchStore';
    import SearchInput from './SearchInput.vue';
    import useLiferayLocale from '../../../composables/useLiferayLocale';

    defineEmits(['update:model-value']);

    const { t } = useI18n();
    const store = useSearchStore();
    const { hasResults, totalResults } = storeToRefs(store);

    const inputRef = ref(null);

    const { urlLocaleParameter } = useLiferayLocale();
</script>

<template>
    <div class="wrapper">
        <div class="container">
            <div class="search__heading">
                <label class="search__label">
                    <span v-if="hasResults" class="search__text">
                        {{ t('search_XresultsFor', totalResults, { count: totalResults }) }}
                    </span>
                    <span v-else class="search__text"> {{ t('search_searchFor') }}: </span>
                    <SearchInput ref="inputRef" />
                </label>
            </div>
        </div>
        <div v-if="!store.isProductSearchMode" class="container search-header link-container">
            <div class="container has-link">
                {{ t('search_exploreProductPortfolio') }}:
                <a href="#" @click.prevent="() => store.toggleProductSearchMode(true)">
                    {{ t('productSearch') }}
                    <span class="icon">
                        <svg class="icon icon-arrow-forward" width="16px" height="16px">
                            <use xlink:href="#icon-arrow-forward" />
                        </svg>
                    </span>
                </a>
            </div>
            <div class="container has-link">
                {{ t('search_findDocumentsInOnePlace') }}:
                <a :href="`${urlLocaleParameter}/support/download-center`">
                    {{ t('search_downloadCenter') }}
                    <span class="icon">
                        <svg class="icon icon-arrow-forward" width="16px" height="16px">
                            <use xlink:href="#icon-arrow-forward" />
                        </svg>
                    </span>
                </a>
            </div>
        </div>
    </div>
</template>
